import styled, { css } from 'styled-components';

interface StyledTitleProps {
    margin?: number[];
    centered?: boolean;
    size?: string;
   
}

export const Title = styled.h1<StyledTitleProps>`
    ${({ centered }) => centered && css`
        text-align: center;
    `};
    font-size: ${({ size }) => size && `${size}rem`};
    margin: ${({ margin }) => margin && margin.map(m => `${m}px`).join(' ')};

`;

export const SubTitle = styled.h2<StyledTitleProps>`
    ${({ centered }) => centered && css`
        text-align: center;
    `};
    font-size: ${({ size }) => size && `${size}px`};
    margin: ${({ margin }) => margin && margin.map(m => `${m}px`).join(' ')}
`;